// Swedish translations
export const sv = {
  // Common
  common: {
    home: 'Hem',
    settings: 'Inställningar',
    language: 'Språk',
    loading: 'Laddar...',
    save: 'Spara',
    cancel: 'Avbryt',
    confirm: 'Bekräfta',
    close: 'Stäng',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Inställningar',
    home: 'Hem',
    howToPlay: 'Hur man spelar',
    pieceRules: 'Pjäsregler',
    language: 'Språk',
    manageSubscription: 'Hantera prenumeration',
    gameHistory: 'Spelhistorik',
    analytics: 'Analys',
    premiumAccount: 'Premiumkonto',
    chatEnabled: 'Chatt: På',
    chatDisabled: 'Chatt: Av',
  },

  // Piece Rules
  pieceRules: {
    title: 'Pjäsregler',
    description: 'Lär dig pjäsernas rörelser',
    selectPiece: 'Välj pjäs',
    selectedLabel: 'Vald:',
    statusLabel: 'Status:',
    statusReady: 'Redo',
    statusViewing: 'Visar',
    movement: 'Rörelse',
    regularMovement: 'Vanlig rörelse',
    ability: 'Förmåga',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Rörelse',
    savage: 'Vild',
    birdtype: 'Fågeltyp',
    birdType: 'Fågeltyp',
    wallBlock: 'Väggblock',
    moveblocks: 'Rörelseblockeringar',
    wallclimb: 'Väggklättring',
    lilypad: 'Näckrosblad',
    poisonous: 'Giftig',
    meadow: 'Äng',
    parasiticfungi: 'Parasitsvamp',
    zombification: 'Zombifiering',
    fungi: 'Svamp',
    traverse: 'Korsa',
    capture: 'Ta',
    faint: 'Svimma',
    leap: 'Hoppa',
    swing: 'Gunga',
    consume: 'Konsumera',
    gamble: 'Spela',
    entangle: 'Trassla in',
    ink: 'Bläck',
    rotate: 'Rotera',
    backstep: 'Baksteg',
    trample: 'Trampa',
    charge: 'Charge',
    lane: 'Bana',
    snakestrike: 'Ormattack',
    shedskin: 'Ömsa skinn',
    house: 'Hus',
    plant: 'Växttyp',
    planttype: 'Växttyp',
    capturehost: 'Ta värd',
    contagion: 'Smitta',
    lonewolf: 'Ensam varg',
    hop: 'Skutt',
    decay: 'Förfall',
    slide: 'Glid',
    block: 'Blockera',
    poison: 'Gift',
    infection: 'Infektion',
    howl: 'Yla',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Björnen kan flytta en ruta i valfri riktning, som en kung i schack',
    bearMovementPost: 'Den blockeras endast av vänliga pjäser (förutom träd, björnar kan klättra i träd!)',
    bearSavage: 'En björn kan övervinna defensiva förmågor som Noshörningens Block',
    bearSavagePost: 'Genom att använda Vild kan björnen ta vilken pjäs som helst från vilken riktning som helst, vilket ger dödlighet',

    // Crane
    craneMovement: 'Tranan kan flytta 1 eller 2 rutor i rät linje',
    craneMovementPost: 'Tranan kan till och med flyga över andra pjäser!',
    craneBirdType: 'Fågeltypspjäser kan inte ta stora eller rovdjurspjäser',
    craneBirdTypePost: 'Detta inkluderar Träd, Noshörning, Björn och Varg',

    // Frog
    frogMovement: 'Grodan hoppar 2 rutor diagonalt',
    frogMovementPost: 'Den kan inte hoppa bara en',
    frogWallBlock: 'Om grodans vanliga 2-rutors väg blockeras av en vägg eller en annan pjäs kan den inte ta',
    frogWallBlockPost: 'Dess vanliga rörelse förkortas till 1 ruta diagonalt',
    frogWallClimb: 'När grodan är vid brätkanten (kolumn A eller E) kan den flytta upp eller ner ett steg',
    frogWallClimbPost: 'Om den inte blockeras av en vänlig pjäs eller en noshörning framför grodan',
    frogLilypad: 'Om grodan ännu inte har flyttat i ett spel kan den hoppa till vilken av de första 3 raderna som helst som en kraftfull defensiv förmåga',
    frogLilypadPost: 'Den kan ta vilken vanlig pjäs som helst med Näckrosbladshopp, utom en noshörning på en högre rad än sig själv',
    frogPoisonous: 'När något djur tar en grodpjäs blir du förgiftad!',
    frogPoisonousPost: 'En förgiftad pjäs hoppar över sitt nästa tillgängliga drag innan den återhämtar sig',

    // Fungi
    fungiMovement: 'Svampen kan flytta en ruta i valfri riktning',
    fungiMovementPost: 'Den blockeras endast av allierade pjäser',
    fungiMeadow: 'Svampen minskar fiendens trädpjäs rörelseförmåga',
    fungiMeadowPost: 'Fiendens trädpjäs kan inte röra sig inom 1 ruta från svamppjäsen',
    fungiParasitic: 'Svampen kan immobilisera fiendens trädpjäs',
    fungiParasiticPost: 'Om svampen är inom 1 ruta från fiendens träd kan den inte röra sig förrän svampen flyttar bort eller tas',
    fungiZombification: 'Svampen kan zombifiera vilket fientligt djur som helst som tar den, vilket ger kontroll över det fientliga djuret i ett drag',
    fungiZombificationPost: 'Den zombifierade pjäsen betraktas också som svamppjäsen för det draget, även om svampen var din kung slutar inte spelet förrän efter det draget',
    fungiFungi: 'Svamp',
    fungiFungiPost: 'Som gift, intrassling och virusinfektion, men inte zombifiering eftersom den kan zombifiera andra!',

    // Goat
    goatMovement: 'Geten kan flytta en ruta i valfri riktning',
    goatMovementPost: 'Geten rör sig långsamt men har kraftfulla förmågor',
    goatTraverse: 'Geten kan korsa över alla andra sammankopplade pjäser för att skapa massiv rörelsepotential',
    goatTraversePost: 'Geten kan inte korsa över svimmade getter eller små pjäser som virus',
    goatCapture: 'Geten kan inte ta några rovdjur',
    goatCapturePost: 'Som björn eller varg',
    goatFaint: 'Geten kan svimma för att undvika att tas, utom av stora pjäser som träd och noshörning',
    goatFaintPost: 'Under svimning kan motståndarna "stå" på den svimmade geten för att stoppa dess rörelse',

    // Monkey
    monkeyMovement: 'Apan kan flytta en ruta i valfri riktning',
    monkeyMovementPost: 'Utan andra pjäser att använda har apan begränsad rörelse',
    monkeyLeap: 'Apan kan, som i damspel, hoppa över andra pjäser i rät linje för enorm rörelsepotential',
    monkeyLeapPost: 'Men om den hoppar över en fientlig pjäs måste apan slå en tärning för att överleva hoppet, 1/6 chans att tas för varje fiende den hoppar över!',
    monkeySwing: 'Om en apa använder ett hopp över ett träd får apan ett bonusdrag',
    monkeySwingPost: 'Att använda trädgunga skapar en kraftfull synergistisk kombination mellan apan och trädpjäsen',
    monkeyConsume: 'Apan kan konsumera en svamp för ett bonusdrag',
    monkeyConsumePost: 'Vilket leder till förödande kombinationer när det kombineras med andra bonusdrag',
    monkeyGamble: 'Förutom att slå tärning för att hoppa över fiender måste apan spela för att ta björnen',
    monkeyGamblePost: 'Apan måste slå 5 eller 6 på en 6-sidig tärning för att ta björnen eller så blir den tagen själv',

    // Octopus
    octopusMovement: 'Bläckfisken flyttar en ruta i valfri riktning',
    octopusCapture: 'Bläckfisken kan bara ta ortogonalt',
    octopusCapturePost: 'Bläckfisken kan ta eller trassla in pjäser på komplexa sätt så kontrollera alltid för röda tagningar och lila intrasslingar!',
    octopusEntangle: 'Bläckfisken kan trassla in intilliggande fientliga pjäser och immobilisera dem, den kan till och med flytta en ruta och trassla in fiender!',
    octopusEntanglePost: 'Intrasslade pjäser kan inte röra sig förrän bläckfisken flyttar bort eller tas',
    octopusInk: 'Bläckfisken kan använda bläck för att undkomma farliga situationer och skapa upp till 3 skuggor',
    octopusInkPost: 'Förvirra fienden och tillåt intressanta bete- och undvikande spel',

    // Penguin
    penguinMovement: 'Pingvinen glider i rät linje i sin inställda riktning tills en vägg eller pjäs blockerar rörelsen',
    penguinMovementPost: 'Efter att ha flyttat kan pingvinen inom samma drag även ställa in sin slutliga riktning',
    penguinRotate: 'I början av matchen är en pingvin vänd nedåt och måste rotera innan den kan glida, även känd som sovande',
    penguinRotatePost: 'Pingvinen kan i vilken position som helst välja att rotera istället för att flytta',
    penguinBirdType: 'Pingvinen har begränsade tagningsförmågor, som tranan kan den inte ta stora eller rovdjurspjäser som träd, noshörning, björn eller varg',
    penguinBirdTypePost: 'Efter att ha tagit kan pingvinen rotera för att vända sig i valfri riktning för strategisk positionering',

    // Rhino
    rhinoMovement: 'Noshörningen flyttar två rutor framåt endast',
    rhinoMovementPost: 'Den kan inte flytta bara 1 ruta',
    rhinoBackStep: 'Noshörningen kan flytta bak-vänster eller bak-höger',
    rhinoCharge: 'Noshörningen kan en gång per spel resa en extra ruta framåt med sin charge-förmåga',
    rhinoChargePost: 'Vilket leder till förödande rörelse- och tagningspotential',
    rhinoTrample: 'Noshörningen tar alla pjäser i sin rörelsebana med Trampa',
    rhinoTramplePost: 'Inklusive en svimmad getpjäs',
    rhinoLane: 'Noshörningen kan byta plats med en annan allierad pjäs vilket tillåter strategiskt banspel',
    rhinoLanePost: 'Men endast om noshörningen och den allierade pjäsen inte har flyttat',

    // Snake
    snakeMovement: 'Ormen kan flytta 2 rutor i rät linje',
    snakeMovementPost: 'Ormen flyttar exakt 2 rutor om den inte blockeras av en vägg eller vänlig pjäs',
    snakeMoveBlocks: 'När den blockeras av en vägg eller pjäs den inte kan ta förkortas ormens rörelse till 1 ruta',
    snakeMoveBlocksPost: 'Den kan fortfarande flytta två rutor även om det finns en mellanliggande pjäs',
    snakeStrike: 'Ormen kan attackera 3 rutor framåt om det finns ett fientligt djur',
    snakeStrikePost: 'Så länge inga mellanliggande pjäser blockerar dess väg',
    snakeShedskin: 'En gång per spel kan ormen ömsa skinn och återvända till första raden om rutan är fri',
    snakeShedskinPost: 'Denna återfödelse ger ormen ett extra liv varje spel',

    // Tree
    treeMovement: 'Trädet kan flytta en ruta framåt eller till vilken ruta som helst på sin rad från sida till sida',
    treeMovementPost: 'Så länge dess väg inte är blockerad',
    treeHouse: 'Trädet kan hysa andra pjäser och skydda dem från fiender som inte kan klättra i träd. Kanske pjäser kan klättra som björn, trana, groda, svamp, get, apa, bläckfisk och orm',
    treeHousePost: 'När en pjäs som kan klättra i ett träd attackerar tar den bara den inhysta pjäsen och skyddar trädet',
    treeTrample: 'Trädet tar, som noshörningen, alla pjäser i en ruta när det flyttar',
    treeTramplePost: 'Detta inkluderar en svimmad get',
    treePlant: 'Trädet är en växt, inte ett djur så det är immunt mot flera effekter',
    treePlantPost: 'Som gift, zombifiering, intrassling och virusinfektion!',

    // Virus
    virusMovement: 'Viruset kan bara flytta till rutor upptagna av djur som är två rutor bort',
    virusMoveBlocks: 'Viruset kan bara flytta en ruta om det är bredvid en vägg',
    virusCaptureHost: 'När viruset landar på (i) någon djurpjäs infekterar det bara dem, de kan fortfarande fortsätta vanligt spel medan de är infekterade',
    virusCaptureHostPost: 'Viruset tar bara pjäsen när det lämnar den infekterade värden',
    virusContagion: 'Viruset kan sprida sig snabbt genom att infektera flera värdar i ett enda drag',
    virusContagionPost: 'Smitta tillåter viruset att göra så många lagliga drag som det vill varje drag',

    // Wolf
    wolfMovement: 'Vargen kan flytta i L-form, som springaren i schack',
    wolfMovementPost: 'Den blockeras inte av några andra pjäser',
    wolfLoneWolf: 'Varg',
    wolfLoneWolfPost: 'Vargen betraktar sig också som ensam när den fortfarande har en svimmad get eller en virusalllierad',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Dra för att utforska • Nyp för att zooma',
    dragToExploreDesktop: '🖱️ Dra för att utforska • Scrolla för att zooma',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Tillbaka',
    next: 'Nästa',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'SANDLÅDA',
    description: 'Experimentera & Öva',
    mode: 'Läge:',
    modeValue: 'Sandlåda',
    status: 'Status:',
    statusReady: 'Redo',
    clearBoard: 'Rensa bräde',
  },

  // Multiplayer
  multiplayer: {
    title: 'FLERSPELAR',
    description: 'Hitta din match och tävla!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Placeringsmatcher',
    matchProgress: 'Matchframsteg',
    gamesCompleted: '{games} / 10 spel slutförda',
    estimatedFinalRating: 'Uppskattad slutbetyg',
    startingRating: 'Startbetyg',
    matchesRemaining: '{matches} matcher kvar',
    findPlacementMatch: 'Hitta placeringsmatch',

    // Matchmaking modes
    findMatch: 'Hitta match',
    competitive: 'Tävlings',
    competitiveDesc: 'Hitta motståndare nära din ranking',
    quick: 'Snabb',
    quickDesc: 'Hitta tävlingsmatcher snabbt',
    casual: 'Casual',
    casualDesc: 'Oranked - spela för skojs skull!',
    placement: 'Placering',
    placementDesc: 'Slutför 10 matcher för att få en rang',
    startSearch: 'Starta sökning',

    // Searching
    searching: 'Söker...',
    mode: 'Läge:',
    inQueue: 'I kö:',
    players: 'spelare',
    playersPlural: 'spelare',
    cancelSearch: 'Avbryt sökning',

    // Game info
    status: 'Status:',
    ready: 'Redo',
    selectingKing: 'Väljer kung',
    placingPieces: 'Placerar pjäser',
    playing: 'Spelar',
    gameType: 'Speltyp:',
    opponent: 'Motståndare:',
    opponentElo: 'Motståndarens ELO:',
    unranked: 'Oranked',

    // Piece placement
    dragPieces: 'Dra pjäser till brädet',
    lightPieces: 'Ljusa pjäser (Du)',
    darkPieces: 'Mörka pjäser (Du)',

    // Waiting states
    waitingForOpponent: 'Väntar på motståndare...',
    waitingForKing: 'Väntar på att motståndaren ska välja sin kung...',

    // Warnings
    invalidPlacement: 'Ogiltig placering',
    lightTurn: 'Det är ljusa spelarens tur!',
    darkTurn: 'Det är mörka spelarens tur!',
    onlyLightPieces: 'Du kan bara placera ljusa pjäser!',
    onlyDarkPieces: 'Du kan bara placera mörka pjäser!',
    mustPlaceOnRow: '{color} pjäser måste placeras på rad {row}!',

    // Chat
    chat: 'Chatt',
    typeMessage: 'Skriv ett meddelande...',
    send: 'Skicka',
  },

  // Main Page
  mainPage: {
    title: 'DJURSCHACK',
    subtitle: 'Ett spel för människor',
    playersOnline: 'Nuvarande spelare online',
    placement: 'Placering',
    placementProgress: 'Placering',
    challengeAI: 'Utmana AI',
    multiplayer: 'Flerspelar',
    sandbox: 'Sandlåda',
    tutorials: 'Handledningar',
    shop: 'Butik',
    collection: 'Samling',
    history: 'Historik',
    analytics: 'Analys',
    courses: 'Kurser',
    upgradeAccount: 'Uppgradera konto',
    signIn: 'Logga in',
    playAsGuest: 'Spela som gäst',
    welcomeBack: 'Välkommen tillbaka! Du brukar spela som',

    // Learn the Pieces section
    learnThePieces: 'Lär dig pjäserna',

    // Learn the Rules section
    learnTheRules: 'Lär dig reglerna',
    premiseTitle: 'Premiss',
    premiseText: 'Zodiac är ett schackalternativ med en DOLD kung från en uppsättning av 13 pjäser, välj en unik uppsättning och bluffa sedan din motståndare för att besegra dem på ett 5x8 bräde',
    selectionTitle: 'Val',
    selectionText: 'För att starta ett spel, välj i hemlighet din kung, placera sedan dina 5 pjäser omväxlande med din motståndare för att skapa ett av över 500 miljarder initiala tillstånd.',
    objectiveTitle: 'Mål',
    objectiveText: 'Antingen läs din motståndare för att TA deras hemliga kung eller TÄVLA din kung över brädet för att säkra seger!',
    competeTitle: 'Tävla',
    competeText: 'Testa dina färdigheter på stegen, utveckla nya personliga tekniker och strategier, ranka upp för att ta dig an de bästa!',
    fullRulesButton: 'För fullständiga officiella regler klicka här',

    // FAQ section
    faqTitle: 'Vanliga frågor',
    faqQuestion1: 'Vad är idén bakom Zodiac schack?',
    faqAnswer1: 'Zodiac schack inspirerades initialt av ord från Bobby Fischer om hans inspiration för att göra Chess960, vi ville expandera på idén att bekämpa rote memorering och fira mänsklig intuition i ofantbart djup!',
    faqQuestion2: 'Varför behöver vi ett schackalternativ',
    faqAnswer2: 'Vi behöver inte! Zodiac vill inte dra bort folk från att spela schack! Det är ett annat alternativ med sina egna styrkor och svagheter, vi hoppas att du har lite kul med det och hjälper oss anpassa detta spel för att förnya nytt spel',
    faqQuestion3: 'Hur vinner man i Zodiac schack?',
    faqAnswer3: 'Det finns tre sätt att vinna: ta din motståndarens dolda kungpjäs, tävla din egen kung till motsatt sida av brädet, eller i en match med tidskontroller, låt din motståndarens tid rinna ut',
    faqQuestion4: 'Är detta en FAQ?',
    faqAnswer4: 'Ja, du kan titta på någon av de listade frågorna i FAQ och om du vill ha lite mer detaljer kan du klicka på frågorna och sedan läsa följande detaljer, som dessa detaljer du läser nu',
    faqQuestion5: 'Hur lång tid tar ett typiskt spel?',
    faqAnswer5: 'Varje spel skiljer sig mycket! Vissa spel är över på 2 drag och vissa kan ta 30 minuter, vi tenderar vanligtvis att hitta att de är i 5-15 minuters intervallet!',
    faqQuestion6: 'Vad händer om ingen kan göra ett lagligt drag?',
    faqAnswer6: 'Om en spelare inte kan göra något lagligt drag (patt), slutar spelet med remi. Spelet kan också sluta med remi genom upprepning (samma brädtillstånd 3 gånger) eller genom ömsesidig överenskommelse mellan spelare!',

    // About section
    aboutButton: 'Om',
    privacyPolicy: 'Integritetspolicy',
    developerInterface: 'Utvecklargränssnitt',
  },

  // About Modal
  about: {
    title: 'Om Zodiac',
    paragraph1: 'Zodiac är ett schackliknande brädspel som kombinerar element av pjäsval från spel som LoL och DotA, med bluffmekanik från poker eller sociala deduktionsspel.',
    paragraph2: 'Tidiga versioner av spelet skapades 2014, under namnet Shadow Chess. 2018 omdesignades det till vad du ser idag, med en uppsättning roliga pjäser med balanserade men unika rörelsemönster och förmågor.',
    paragraph3: 'Vår vision är att spela in all användares speldata för att fortsätta utveckla spelet i ett försök att hålla spelet uppfriskande och uppmuntra nya spel.',
    paragraph4: 'Med Zodiacs gigantiska sökutrymme, dold information och öppnande brädpositioner hoppas vi kunna avvärja AI-dominans och hålla zodiac som ett spel för människor!',
  },

  // Privacy Policy
  privacy: {
    title: 'Integritetspolicy',
    lastUpdated: 'Senast uppdaterad',

    introduction: {
      title: 'Introduktion',
      p1: 'Välkommen till Zodiac Chess ("vi", "vårt" eller "oss"). Vi är engagerade i att skydda din integritet och se till att du har en säker och njutbar spelupplevelse. Denna integritetspolicy förklarar hur vi samlar in, använder, avslöjar och skyddar din information när du använder vår webbplats och vårt spel.',
      p2: 'Genom att använda Zodiac Chess samtycker du till insamlingen och användningen av information i enlighet med denna policy. Om du inte samtycker till våra policyer och praxis, vänligen använd inte vår tjänst.',
      contact: 'Kontakta oss på:',
    },

    infoCollect: {
      title: 'Information vi samlar in',
      accountInfo: {
        title: '1. Kontoinformation',
        item1: 'E-postadress: Krävs för kontoskapande och kommunikation',
        item2: 'Användarnamn: Ditt valda visningsnamn',
        item3: 'Lösenord: Krypterat och säkert lagrat',
      },
      gameData: {
        title: '2. Speldata',
        item1: 'Spelstatistik: Vinster, förluster, ELO-betyg, placeringsmatchframsteg',
        item2: 'Speldata: Pjäsval, gjorda drag, använda strategier',
        item3: 'Matchhistorik: Register över spelade spel, mötta motståndare',
        item4: 'Köp i spelet: Kosmetiska föremål och premium medlemskapsstatus',
      },
      technicalData: {
        title: '3. Teknisk data',
        item1: 'Enhetsinformation: Webbläsartyp, operativsystem',
        item2: 'Användningsdata: Besökta sidor, spenderad tid, använda funktioner',
        item3: 'Lokal lagring: Språkpreferenser, UI-inställningar, tillfälligt speltillstånd',
      },
    },

    children: {
      title: 'Barns integritet (COPPA-efterlevnad)',
      p1: 'Zodiac Chess är utformat för att vara familjevänligt och lämpligt för spelare i alla åldrar, inklusive barn. Vi tar särskild omsorg om att följa Children\'s Online Privacy Protection Act (COPPA).',
      p2: 'För användare under 13 år: Vi rekommenderar att barn använder vårt gästspelsläge, som inte kräver kontoskapande eller datainsamling. Gästkonton har inte tillgång till textchattfunktioner, vilket säkerställer att barn inte exponeras för kommunikation med det bredare internet. Om ett barn skapar ett konto kräver vi föräldrasamtycke innan vi samlar in någon personlig information.',
      p3: 'Vi samlar INTE medvetet in, använder eller delar personlig information från barn under 13 år utan verifierat föräldrasamtycke.',
      p4: 'Chattsäkerhet: Textchatt är automatiskt inaktiverad för alla gäst-/tillfälliga konton. Standardkontoinnehavare har möjlighet att inaktivera chattfunktionaliteten i sina kontoinställningar när som helst.',
      parentalRights: 'Föräldrar har rätt att:',
      right1: 'Granska sitt barns personliga information',
      right2: 'Begära radering av sitt barns data',
      right3: 'Vägra ytterligare insamling eller användning av deras barns information',
      contactUs: 'För att utöva dessa rättigheter eller om du tror att ditt barn har gett oss personlig information, vänligen kontakta oss omedelbart på contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Hur vi använder din information',
      item1: 'Tillhandahålla och förbättra våra speltjänster',
      item2: 'Matcha dig med lämpliga motståndare baserat på färdighetsnivå',
      item3: 'Spåra ditt framsteg, statistik och prestationer',
      item4: 'Bearbeta betalningar för premium medlemskap och kosmetiska föremål',
      item5: 'Skicka viktiga tjänstemeddelanden och uppdateringar',
      item6: 'Analysera speldata för att förbättra spelbalans och funktioner',
    },

    thirdParty: {
      title: 'Tredjepartstjänster',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Vi använder Firebase för autentisering, databaslagring och flerspelarfunktionalitet. Firebase kan samla in vissa data enligt beskrivningen i deras integritetspolicy.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Vi använder Stripe för att bearbeta betalningar för premium medlemskap och köp i appen. Stripe hanterar all betalningskortsinformation - vi ser eller lagrar aldrig dina fullständiga betalningsuppgifter.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Vår webbplats är värd på Netlify, som kan samla in standard webbhotelldata såsom IP-adresser och åtkomstloggar.',
      },
      adsense: {
        title: 'Google AdSense (framtid)',
        description: 'Vi kan visa annonser genom Google AdSense. Dessa annonser kan använda cookies för personalisering. För barnriktat innehåll kommer vi endast att visa icke-personaliserade annonser i enlighet med COPPA.',
      },
      viewPolicy: 'Visa deras integritetspolicy',
    },

    cookies: {
      title: 'Cookies och lokal lagring',
      description: 'Vi använder webbläsarens lokala lagring (liknande cookies) för att förbättra din upplevelse:',
      item1: 'Språkpreferens: Kom ihåg ditt valda språk',
      item2: 'Kontosession: Håller dig inloggad (fungerar med Firebase)',
      item3: 'Spelinställningar: Kom ihåg dina UI-preferenser och sandlådeinställningar',
      item4: 'Reklamcookies: Om du samtycker kan tredjepartsannonstjänster använda cookies för annonspersonalisering',
    },

    security: {
      title: 'Datasäkerhet',
      p1: 'Vi implementerar lämpliga säkerhetsåtgärder för att skydda din information:',
      item1: 'Lösenordskryptering: Alla lösenord krypteras med branschstandardmetoder',
      item2: 'Säkra anslutningar: HTTPS-kryptering för all dataöverföring',
      item3: 'Firebase säkerhetsregler: Strikta databaskontroller',
      p2: 'Ingen överföringsmetod över internet är dock 100 % säker. Även om vi strävar efter att skydda dina data kan vi inte garantera absolut säkerhet.',
    },

    retention: {
      title: 'Datalagring',
      p1: 'Vi behåller din data enligt följande:',
      item1: 'Aktiva konton: Data behålls medan ditt konto är aktivt',
      item2: 'Inaktiva konton: Om ditt konto är inaktivt i 10 år kan vi radera din data',
    },

    rights: {
      title: 'Dina integritetsrättigheter',
      description: 'Beroende på din plats kan du ha följande rättigheter:',
      access: {
        title: 'Åtkomst:',
        description: 'Begär en kopia av din personliga data',
      },
      correction: {
        title: 'Korrigering:',
        description: 'Begär korrigeringar av din data',
      },
      deletion: {
        title: 'Radering:',
        description: 'Begär radering av ditt konto och data',
      },
      portability: {
        title: 'Dataportabilitet:',
        description: 'Begär din data i ett portabelt format',
      },
      optOut: {
        title: 'Avanmälan:',
        description: 'Avanmäl dig från marknadsföringskommunikation',
      },
      contact: 'För att utöva någon av dessa rättigheter, vänligen kontakta oss på contact@zodiac-chess.com',
    },

    international: {
      title: 'Internationella användare',
      p1: 'Zodiac Chess drivs från Nya Zeeland. Om du får tillgång till vår tjänst från utanför Nya Zeeland, vänligen var medveten om att din information kan överföras till, lagras och bearbetas i Nya Zeeland och andra länder där våra tjänsteleverantörer verkar.',
      p2: 'Genom att använda vår tjänst samtycker du till överföringen av din information till länder utanför ditt hemland, som kan ha andra dataskyddslagar.',
    },

    changes: {
      title: 'Ändringar i denna integritetspolicy',
      description: 'Vi kan uppdatera denna integritetspolicy då och då. Vi kommer att meddela dig om eventuella ändringar genom att publicera den nya integritetspolicyn på denna sida och uppdatera datumet "Senast uppdaterad". Betydande ändringar kommer att kommuniceras via e-post eller ett framträdande meddelande på vår webbplats.',
    },

    contact: {
      title: 'Kontakta oss',
      description: 'Om du har några frågor, bekymmer eller förfrågningar angående denna integritetspolicy eller våra datapraxis, vänligen kontakta oss:',
      email: 'E-post:',
      company: 'Företag:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Användarvillkor',
    lastUpdated: 'Senast uppdaterad',
    back: 'Tillbaka',
    viewPrivacyPolicy: 'Visa Integritetspolicy',
    acknowledgment: 'Genom att använda Zodiac Chess bekräftar du att du har läst, förstått och samtycker till att vara bunden av dessa Användarvillkor.',
    acceptance: {
      title: '1. Godkännande av Villkor',
      p1: 'Genom att komma åt och använda Zodiac Chess ("Tjänsten") accepterar du och samtycker till att vara bunden av dessa Användarvillkor. Om du inte godkänner dessa villkor, vänligen använd inte Tjänsten.',
      p2: 'Vi förbehåller oss rätten att ändra dessa villkor när som helst. Fortsatt användning av Tjänsten efter ändringar utgör godkännande av de ändrade villkoren.',
    },
    description: {
      title: '2. Beskrivning av Tjänsten',
      p1: 'Zodiac Chess är ett online strategiskt brädspel med unika djurfigurer med speciella förmågor. Tjänsten inkluderar:',
      feature1: 'Enspelarlge mot AI-motståndare',
      feature2: 'Flerspelar-matchmaking och tävlingsspel',
      feature3: 'Interaktiva handledningar och läromedel',
      feature4: 'Kontoskapande och progressionsövervakning',
      feature5: 'Valfria premiumabonnemangsfunktioner',
      feature6: 'Kosmetiska anpassningsalternativ',
    },
    accounts: {
      title: '3. Användarkonton',
      eligibility: {
        title: '3.1 Behörighet',
        p1: 'Du måste vara minst 13 år gammal för att skapa ett konto. Användare under 13 kan använda gästspelläge under föräldraövervakning men kan inte skapa konton.',
      },
      responsibilities: {
        title: '3.2 Kontosäkerhet',
        p1: 'Du är ansvarig för:',
        item1: 'Att upprätthålla sekretessen för ditt lösenord',
        item2: 'Alla aktiviteter som sker under ditt konto',
        item3: 'Att omedelbart meddela oss om obehörig användning',
        p2: 'Vi är inte ansvariga för förlust eller skada som uppstår från obehörig kontoåtkomst.',
      },
      prohibited: {
        title: '3.3 Förbjudna Aktiviteter',
        p1: 'Du får INTE:',
        item1: 'Dela ditt konto med andra',
        item2: 'Använda flera konton för att manipulera rankingar',
        item3: 'Använda bottar, skript eller automatiserade verktyg för att spela',
        item4: 'Trakassera, misshandla eller hota andra spelare',
        item5: 'Utnyttja buggar eller glitchar för orättvis fördel',
        item6: 'Reverse-engineera eller försöka komma åt vår källkod',
        p2: 'Brott mot dessa regler kan resultera i kontosuspension eller permanent avstängning.',
      },
    },
    premium: {
      title: '4. Premiumabonnemang',
      billing: {
        title: '4.1 Fakturering',
        p1: 'Premiumabonnemang behandlas via Stripe. Genom att köpa ett premiumabonnemang godkänner du att vi debiterar din betalningsmetod löpande tills du avbryter.',
        p2: 'Abonnemangsavgifter är:',
        item1: 'Månadsplan: Debiteras månadsvis på årsdagen av ditt köpdatum',
        item2: 'Årsplan: Debiteras årligen på årsdagen av ditt köpdatum',
        p3: 'Priserna kan ändras med 30 dagars varsel till aktiva abonnenter.',
      },
      cancellation: {
        title: '4.2 Avbokning',
        p1: 'Du kan avbryta ditt abonnemang när som helst via dina kontoinställningar eller genom att kontakta support. Avbokningen träder i kraft i slutet av din nuvarande faktureringsperiod.',
        p2: 'Du behåller premiumfunktioner till slutet av din betalda period, även efter avbokning.',
      },
      refunds: {
        title: '4.3 Återbetalningar',
        p1: 'Månadsabonnemang: Inga återbetalningar för delmånader. Avbryt när som helst för att stoppa framtida debiteringar.',
        p2: 'Årsabonnemang: Full återbetalning om begäran görs inom 7 dagar från köp. Efter 7 dagar är återbetalningar enligt vårt gottfinnande.',
        p3: 'Kosmetiska köp: Generellt ej återbetalningsbara. Kontakta support för exceptionella omständigheter.',
      },
    },
    acceptable: {
      title: '5. Policy för Acceptabel Användning',
      p1: 'Du samtycker till att använda Zodiac Chess på ett respektfullt och lagligt sätt. Förbjudet beteende inkluderar:',
      item1: 'Fusk, hackning eller utnyttjande av spelmekanik',
      item2: 'Trakasserier, hatpropaganda eller diskriminerande språk',
      item3: 'Spammning, reklam eller värvning',
      item4: 'Delning av olämpligt innehåll (om chatt eller användargenererat innehåll är aktiverat)',
      item5: 'Att utge sig för att vara andra användare eller personal',
      item6: 'Försök att störa eller skada Tjänsten',
      p2: 'Vi förbehåller oss rätten att utreda överträdelser och vidta lämpliga åtgärder, inklusive kontoavslutning och rapportering till myndigheter vid behov.',
    },
    intellectual: {
      title: '6. Immateriella Rättigheter',
      ownership: {
        title: '6.1 Vårt Innehåll',
        p1: 'Allt spelinnehåll, inklusive men inte begränsat till spelmekanik, konstverk, animationer, ljudeffekter, kod och design, ägs av Animal Chess Limited eller våra licensgivare.',
        p2: 'Du beviljas en begränsad, icke-exklusiv, icke-överförbar licens att använda Tjänsten endast för personligt underhållningssyfte.',
      },
      userContent: {
        title: '6.2 Användarinnehåll',
        p1: 'Genom att skicka in innehåll (såsom chattmeddelanden, användarnamn eller profilinformation) beviljar du oss en världsomspännande, royaltyfri licens att använda, visa och distribuera det innehållet i samband med Tjänsten.',
        p2: 'Du intygar att du äger eller har de nödvändiga rättigheterna till allt innehåll du skickar in.',
      },
    },
    disclaimers: {
      title: '7. Friskrivningar och Ansvarsbegränsningar',
      p1: 'TJÄNSTEN TILLHANDAHÅLLS "SOM DEN ÄR" UTAN GARANTIER AV NÅGOT SLAG, VARKEN UTTRYCKLIGA ELLER UNDERFÖRSTÅDDA.',
      p2: 'Vi garanterar inte att:',
      item1: 'Tjänsten kommer att vara oavbruten eller felfri',
      item2: 'Defekter kommer att korrigeras',
      item3: 'Tjänsten är fri från virus eller skadliga komponenter',
      item4: 'Resultat från användning av Tjänsten kommer att möta dina förväntningar',
      p3: 'I DEN MAXIMALA UTSTRÄCKNING SOM TILLÅTS ENLIGT LAG ÄR VI INTE ANSVARIGA FÖR:',
      item5: 'Indirekta, tillfälliga eller följdskador',
      item6: 'Förlust av vinst, data eller goodwill',
      item7: 'Tjänstavbrott eller dataförlust',
      item8: 'Skador som överstiger det belopp du betalat oss under de senaste 12 månaderna',
    },
    privacy: {
      title: '8. Integritet',
      p1: 'Din användning av Tjänsten regleras också av vår Integritetspolicy, som förklarar hur vi samlar in, använder och skyddar din personliga information.',
      p2: 'Genom att använda Tjänsten samtycker du till våra datapraxis enligt beskrivningen i Integritetspolicyn.',
    },
    changes: {
      title: '9. Ändringar av Villkor',
      p1: 'Vi förbehåller oss rätten att ändra dessa Användarvillkor när som helst. Vi kommer att meddela användare om väsentliga ändringar via:',
      item1: 'E-postmeddelande till registrerade användare',
      item2: 'Framträdande meddelande på webbplatsen',
      item3: 'Uppdaterat "Senast uppdaterad"-datum högst upp på denna sida',
      p2: 'Din fortsatta användning av Tjänsten efter ändringar utgör godkännande av de ändrade villkoren.',
    },
    governing: {
      title: '10. Tillämplig Lag',
      p1: 'Dessa Användarvillkor regleras av lagarna i Nya Zeeland, utan hänsyn till lagvalsprinciper.',
      p2: 'Eventuella tvister som uppstår från dessa villkor eller din användning av Tjänsten ska lösas i domstolarna i Nya Zeeland.',
    },
    contact: {
      title: '11. Kontaktinformation',
      p1: 'För frågor, funderingar eller support angående dessa Användarvillkor:',
      email: 'E-post:',
      company: 'Företag:',
      address: 'Adress:',
    },
    severability: {
      title: '12. Avskiljbarhet',
      p1: 'Om någon bestämmelse i dessa villkor befinns vara ogenomförbar eller ogiltig, kommer den bestämmelsen att begränsas eller elimineras i minsta nödvändiga omfattning, och de återstående bestämmelserna kommer att förbli i full kraft och effekt.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookie-policy',
    lastUpdated: 'Senast uppdaterad',
    browserInstructions: {
      chrome: 'Inställningar → Sekretess och säkerhet → Cookies',
      firefox: 'Inställningar → Sekretess och säkerhet → Kakor och webbplatsdata',
      safari: 'Inställningar → Sekretess → Cookies och webbplatsdata',
      edge: 'Inställningar → Sekretess, sökning och tjänster → Cookies',
    },
    cookieTable: {
      name: 'Cookie-namn',
      purpose: 'Syfte',
      duration: 'Varaktighet',
      type: 'Typ',
    },
    relatedPolicies: {
      title: 'Relaterade policyer',
      description: 'För mer information om hur vi hanterar dina uppgifter, se:',
      privacy: 'Integritetspolicy',
      terms: 'Användarvillkor',
    },

    introduction: {
      title: 'Introduktion',
      p1: 'Denna Cookie-policy förklarar hur Zodiac Chess ("vi" eller "oss") använder cookies och liknande tekniker när du besöker vår webbplats.',
      p2: 'Genom att använda vår webbplats samtycker du till vår användning av cookies i enlighet med denna policy. Om du inte samtycker, inaktivera cookies i dina webbläsarinställningar eller använd inte vår webbplats.',
    },
    what: {
      title: 'Vad är Cookies?',
      p1: 'Cookies är små textfiler som placeras på din enhet (dator, smartphone, surfplatta) när du besöker en webbplats. De används i stor utsträckning för att få webbplatser att fungera effektivt och ge information till webbplatsägare.',
      p2: 'Cookies tjänar olika syften, inklusive att komma ihåg dina preferenser, analysera webbplatsanvändning och aktivera vissa funktioner.',
    },
    types: {
      title: 'Typer av Cookies vi använder',
      necessary: {
        title: '1. Nödvändiga Cookies',
        description: 'Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt. Utan dessa cookies kan tjänster du har begärt inte tillhandahållas.',
        examples: 'Exempel:',
        item1: 'Autentiseringscookies - Håller dig inloggad på ditt konto',
        item2: 'Säkerhetscookies - Skyddar mot bedräglig aktivitet',
        item3: 'Sessionscookies - Upprätthåller ditt spelstatus under en session',
        item4: 'Cookie-samtyckesinställningar - Kommer ihåg dina cookie-val',
      },
      analytics: {
        title: '2. Analytiska Cookies',
        description: 'Dessa cookies hjälper oss att förstå hur besökare interagerar med vår webbplats genom att samla in anonym information om sidbesök, spenderad tid och använda funktioner.',
        provider: 'Leverantör: Firebase Analytics (Google)',
        purpose: 'Syfte:',
        item1: 'Mäta webbplatstrafik och användarengagemang',
        item2: 'Identifiera populära funktioner och sidor',
        item3: 'Förstå användardemografi (åldersgrupp, allmän plats)',
        item4: 'Förbättra webbplatsens prestanda och användarupplevelse',
      },
      advertising: {
        title: '3. Reklam-Cookies',
        description: 'Dessa cookies används för att visa annonser som är relevanta för dig. De begränsar också antalet gånger du ser en annons och hjälper till att mäta effektiviteten av reklamkampanjer.',
        provider: 'Leverantör: Google AdSense',
        purpose: 'Syfte:',
        item1: 'Visa personanpassade annonser baserat på dina intressen',
        item2: 'Mäta annonsprestanda och engagemang',
        item3: 'Förhindra att samma annons visas för många gånger',
        note: 'Obs: Premium-prenumeranter ser aldrig annonser, oavsett cookie-inställningar.',
      },
    },
    firstThird: {
      title: 'Förstaparts- vs Tredjepartscookies',
      firstParty: {
        title: 'Förstapartscookies',
        description: 'Detta är cookies som ställs in direkt av Zodiac Chess. Vi använder dem för grundläggande webbplatsfunktionalitet, autentisering och för att komma ihåg dina preferenser.',
      },
      thirdParty: {
        title: 'Tredjepartscookies',
        description: 'Detta är cookies som ställs in av externa tjänster vi använder, som Google Analytics och Google AdSense. Tredjepartscookies omfattas av dessa leverantörers integritetspolicyer.',
      },
    },
    specific: {
      title: 'Specifika Cookies vi använder',
      tableHeader: 'Nedan finns en detaljerad lista över cookies som används på vår webbplats:',
    },
    control: {
      title: 'Hur man kontrollerar Cookies',
      consent: {
        title: '1. Cookie-samtycksbanner',
        description: 'När du först besöker vår webbplats ser du en cookie-samtycksbanner. Du kan:',
        item1: 'Acceptera alla - Tillåt alla cookies (nödvändiga, analytiska och reklam)',
        item2: 'Avvisa valfria - Tillåt endast nödvändiga cookies (ingen analys eller annonser)',
        item3: 'Anpassa - Välj exakt vilka typer av cookies du vill tillåta',
      },
      browser: {
        title: '2. Webbläsarinställningar',
        description: 'De flesta webbläsare låter dig kontrollera cookies via sina inställningar. Du kan:',
        item1: 'Blockera alla cookies',
        item2: 'Acceptera endast förstapartscookies',
        item3: 'Ta bort cookies efter varje surfsession',
        item4: 'Visa och ta bort enskilda cookies',
        links: 'Här är länkar till cookie-hantering för populära webbläsare:',
      },
      optOut: {
        title: '3. Opt-out-verktyg',
        description: 'För reklam-cookies specifikt kan du välja bort personanpassade annonser:',
        googleLink: 'Google Annonsinställningar',
        googleDesc: ' - Hantera Google personanpassade annonser',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Välj bort intressebaserad reklam',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU-specifikt opt-out-verktyg',
      },
    },
    impact: {
      title: 'Påverkan av att inaktivera Cookies',
      p1: 'Om du inaktiverar eller vägrar cookies, observera att:',
      item1: 'Vissa delar av webbplatsen kanske inte fungerar korrekt',
      item2: 'Du kan behöva ange dina preferenser på nytt vid varje besök',
      item3: 'Du kan loggas ut från ditt konto',
      item4: 'Nödvändiga cookies krävs för att webbplatsen ska fungera - att inaktivera dem kommer att hindra dig från att använda kärnfunktioner',
    },
    updates: {
      title: 'Uppdateringar av denna Cookie-policy',
      p1: 'Vi kan uppdatera denna Cookie-policy då och då för att återspegla förändringar i våra rutiner eller av juridiska, regulatoriska eller operativa skäl.',
      p2: 'Vi kommer att meddela dig om väsentliga ändringar genom att uppdatera datumet "Senast uppdaterad" högst upp på denna sida. Vänligen granska denna policy regelbundet.',
    },
    contact: {
      title: 'Kontakta oss',
      p1: 'Om du har frågor om vår användning av cookies eller denna Cookie-policy, kontakta oss:',
      email: 'E-post:',
      company: 'Företag:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Pingvin',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',
  },

  // Piece names
  pieces: {
    Bear: 'Björn',
    Crane: 'Trana',
    Frog: 'Groda',
    Fungi: 'Svamp',
    Goat: 'Get',
    Monkey: 'Apa',
    Octopus: 'Bläckfisk',
    Penguin: 'Pingvin',
    Rhino: 'Noshörning',
    Snake: 'Orm',
    Tree: 'Träd',
    Virus: 'Virus',
    Wolf: 'Varg',
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
